<template>
  <section class="page-card">
    <h1 class="page-title">{{ $t('pages.dashboard') }}</h1>
    <div class="filter-bar">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="-"
        :start-placeholder="$t('common.start')"
        :end-placeholder="$t('common.end')"
        class="filter-item-wide"
        size="small"
      ></el-date-picker>
      <el-input v-model="search.area_code" :placeholder="$t('common.areaCode')" class="filter-item" size="small"></el-input>
      <el-button type="primary" size="small" @click="loadData">{{ $t('actions.search') }}</el-button>
    </div>
    <div class="summary-grid">
      <div class="metric-card">
        <div class="metric-label">{{ $t('pages.newUsers') }}</div>
        <div class="metric-value">{{ totals.new_user_count }}</div>
      </div>
      <div class="metric-card">
        <div class="metric-label">{{ $t('common.rechargeAmount') }}</div>
        <div class="metric-value">{{ totals.recharge_amount }}</div>
      </div>
      <div class="metric-card">
        <div class="metric-label">{{ $t('common.withdrawAmount') }}</div>
        <div class="metric-value">{{ totals.withdraw_amount }}</div>
      </div>
      <div class="metric-card">
        <div class="metric-label">{{ $t('common.firstRechargeUsers') }}</div>
        <div class="metric-value">{{ totals.first_recharge_user_count }}</div>
      </div>
    </div>
    <div class="table-scroll">
      <el-table :data="tableData" border stripe>
        <el-table-column prop="date" :label="$t('common.date')" min-width="100"></el-table-column>
        <el-table-column prop="pkg" :label="$t('common.packageName')" min-width="150"></el-table-column>
        <el-table-column prop="area_code" :label="$t('common.areaCode')" min-width="80"></el-table-column>
        <el-table-column prop="new_user_count" :label="$t('pages.newUsers')" min-width="90"></el-table-column>
        <el-table-column prop="new_register_user_count" :label="$t('pages.newRegisteredAccounts')" min-width="110"></el-table-column>
        <el-table-column prop="active_count" :label="$t('pages.activeUsers')" min-width="100"></el-table-column>
        <el-table-column prop="recharge_amount" :label="$t('common.rechargeAmount')" min-width="120"></el-table-column>
        <el-table-column prop="recharge_user" :label="$t('common.rechargeUsers')" min-width="110"></el-table-column>
        <el-table-column prop="new_recharge_amount" :label="$t('pages.newPaidAmount')" min-width="130"></el-table-column>
        <el-table-column prop="new_recharge_user" :label="$t('pages.newPaidUsers')" min-width="120"></el-table-column>
        <el-table-column prop="withdraw_amount" :label="$t('common.withdrawAmount')" min-width="120"></el-table-column>
        <el-table-column prop="withdraw_user" :label="$t('common.withdrawUsers')" min-width="120"></el-table-column>
        <el-table-column prop="first_recharge_user_count" :label="$t('common.firstRechargeUsers')" min-width="130"></el-table-column>
        <el-table-column prop="day_1_stay_rate" :label="$t('pages.day1Retention')" min-width="100"></el-table-column>
        <el-table-column prop="day_3_stay_rate" :label="$t('pages.day3Retention')" min-width="100"></el-table-column>
        <el-table-column prop="day_7_stay_rate" :label="$t('pages.day7Retention')" min-width="100"></el-table-column>
      </el-table>
    </div>
    <el-pagination
      :total="count"
      :current-page.sync="search.page"
      :page-size="search.size"
      layout="total, prev, pager, next"
      @current-change="loadData"
    ></el-pagination>
  </section>
</template>

<script>
import { defaultDateRange, isDateRangeOverDays } from '../utils/date';

export default {
  name: 'Dashboard',
  data() {
    return {
      dateRange: defaultDateRange(),
      search: { page: 1, size: 20, area_code: '' },
      tableData: [],
      count: 0
    };
  },
  computed: {
    totals() {
      const total = {
        new_user_count: 0,
        recharge_amount: 0,
        withdraw_amount: 0,
        first_recharge_user_count: 0
      };
      this.tableData.forEach(item => {
        total.new_user_count += Number(item.new_user_count || 0);
        total.recharge_amount += Number(item.recharge_amount || 0);
        total.withdraw_amount += Number(item.withdraw_amount || 0);
        total.first_recharge_user_count += Number(item.first_recharge_user_count || 0);
      });
      total.recharge_amount = total.recharge_amount.toFixed(2);
      total.withdraw_amount = total.withdraw_amount.toFixed(2);
      return total;
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    validateDateRange() {
      if (!this.dateRange || this.dateRange.length !== 2) return true;
      if (!isDateRangeOverDays(this.dateRange[0], this.dateRange[1], 31)) return true;
      this.$message.error(this.$t('common.dateRangeTooLong'));
      return false;
    },
    async loadData() {
      if (!this.validateDateRange()) return;
      const params = Object.assign({}, this.search, {
        date__gte: this.dateRange && this.dateRange[0],
        date__lte: this.dateRange && this.dateRange[1]
      });
      const resp = await this.$axios.get('/admin/exagent/console/stats/overview/', { params: params });
      if (resp.data.status !== 0) return;
      const data = resp.data.data || {};
      this.tableData = data.list || [];
      this.count = data.count || 0;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue